import { Button } from '@shared/components/ui/button';
import { useTranslation } from 'react-i18next';
import type { DataLoadUploadDefinition } from '../../models';

interface UploadListRowProps {
  upload: DataLoadUploadDefinition;
  isLast: boolean;
  onUpload: (upload: DataLoadUploadDefinition) => void;
}

export function UploadListRow({ upload, isLast, onUpload }: UploadListRowProps) {
  const { t } = useTranslation('dataLoadModule');

  return (
    <div
      className={`grid gap-3 px-4 py-4 sm:grid-cols-[1fr_auto] sm:items-center sm:gap-6 ${!isLast ? 'border-b border-border' : ''}`}
      data-testid={`data-load-row-${upload.id}`}
    >
      <div className="min-w-0">
        <p className="text-sm font-medium text-foreground">{t(upload.titleKey)}</p>
        <p className="mt-1 text-sm text-muted-foreground">{t(upload.descriptionKey)}</p>
      </div>

      <div className="flex sm:justify-end">
        <Button
          variant="outline"
          size="sm"
          onClick={() => onUpload(upload)}
          data-testid={`data-load-upload-button-${upload.id}`}
        >
          {t('actions.upload', 'Cargar')}
        </Button>
      </div>
    </div>
  );
}
